import React from 'react';

const Messages = React.lazy(() => import('./MessagesPage' /* webpackChunkName: "Messages" */));
export default function MessagesInitializer() {
    return <Messages />;
}
